import { X } from 'lucide-react';
import { COUNT_LOCATION_LABELS } from './stockAuditTypes';
interface Props {setShowNewModal:(v:boolean)=>void;newName:string;setNewName:(v:string)=>void;newType:'blind'|'standard';setNewType:(v:'blind'|'standard')=>void;newLocation:string;setNewLocation:(v:string)=>void;createAudit:()=>void}
export function NewStockAuditModal({setShowNewModal,newName,setNewName,newType,setNewType,newLocation,setNewLocation,createAudit}:Props){return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
          <div className="w-full max-w-md rounded-xl bg-white shadow-xl">
            <div className="flex items-center justify-between border-b border-gray-200 px-5 py-4">
              <h3 className="text-lg font-semibold text-gray-900">New Stock Audit</h3>
              <button onClick={() => setShowNewModal(false)}><X className="h-5 w-5 text-gray-400" /></button>
            </div>
            <div className="space-y-4 px-5 py-4">
              <div>
                <label className="mb-1 block text-sm font-medium text-gray-700">Audit Name</label>
                <input
                  type="text"
                  value={newName}
                  onChange={(e) => setNewName(e.target.value)}
                  placeholder="e.g. Oct 2026 – Main Warehouse"
                  className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none focus:ring-1 focus:ring-[var(--ink-0)]"
                />
              </div>
              <div>
                <label className="mb-1 block text-sm font-medium text-gray-700">Type</label>
                <select
                  value={newType}
                  onChange={(e) => setNewType(e.target.value as 'blind' | 'standard')}
                  className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none"
                >
                  <option value="blind">Blind (system qty hidden)</option>
                  <option value="standard">Standard (system qty visible)</option>
                </select>
              </div>
              <div>
                <label htmlFor="audit-location" className="mb-1 block text-sm font-medium text-gray-700">Location</label>
                <select
                  id="audit-location"
                  value={newLocation}
                  onChange={(e) => setNewLocation(e.target.value)}
                  className="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm focus:border-[var(--ink-0)] focus:outline-none"
                >
                  {Object.entries(COUNT_LOCATION_LABELS).map(([code, label]) => (
                    <option key={code} value={code}>{label}</option>
                  ))}
                </select>
              </div>
            </div>
            <div className="flex justify-end gap-2 border-t border-gray-200 px-5 py-4">
              <button onClick={() => setShowNewModal(false)} className="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">Cancel</button>
              <button onClick={createAudit} disabled={!newName.trim()} className="rounded-lg bg-[var(--ink-0)] px-4 py-2 text-sm font-medium text-white hover:bg-[var(--ink-1)] disabled:opacity-50">
                Start Audit
              </button>
            </div>
          </div>
        </div>
);}
